export default __webpack_public_path__ + "static/media/gas-cylinder.d4853bc3.svg";